import { useEffect } from 'react';
import { useLocation, useMatch } from 'react-router';

import { useRouteTracker } from '../model/routeTrackerContext';
import { RouteTrackerContextType } from '../model/routeTrackerContextType';

const isReloadTheSamePage = (
    history: RouteTrackerContextType[],
    title: string,
    params?: Record<string, string | undefined>,
) => {
    if (history.length === 0) return false;

    const { pageTitle, params: lastParams } = history[history.length - 1];
    return (
        pageTitle == title &&
        (!params || JSON.stringify(params) == JSON.stringify(lastParams))
    );
};

export const RouteTrackerDecorator = ({
    title,
    path,
    children,
}: React.PropsWithChildren<{
    title: string;
    path: string;
}>) => {
    const location = useLocation();
    const { history, pushToHistory } = useRouteTracker();
    const match = useMatch(path);

    useEffect(() => {
        if (!match) {
            return;
        }
        if (isReloadTheSamePage(history, title, match.params)) {
            return;
        }
        pushToHistory({
            pagePath: location.pathname,
            pageTitle: title,
            params: match.params,
        });
    }, [match]);

    return <>{children}</>;
};
